import type { QueryKey, useQueryClient } from '@tanstack/vue-query'

/**
 * Update a single query by key only if it is not stale.
 */
export function updateNonStaleQuery<TData>(
  queryClient: ReturnType<typeof useQueryClient>,
  queryKey: QueryKey,
  updater: (oldData: TData | undefined) => TData | undefined,
) {
  const query = queryClient.getQueryCache().find(queryKey)

  if (query && !query.isStale()) {
    queryClient.setQueryData<TData>(queryKey, updater)
  }
}
